import { stopBubbling } from '@Utils/helpers/eventHelpers';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import { Popover } from '@mui/material';
import { Tooltip } from '@mui/material';
import cx from 'classnames';
import React from 'react';
import Styles from './DomElements.scss';
import Label from './Label';

interface ISelectProps {
    value: string;
    children: any;
    label?: string;
    containerClassName?: string;
    containerStyle?: object;
    inputStyle?: object;
    disabled?: boolean;
    onClose?: any;
    anchor?: any;
    id?: string;
    placeholder?: string;
    tooltip?: string;
    title?: string;
}

interface ISelectState {
    isOpen: boolean;
    id: string;
}

class Select extends React.Component<ISelectProps, ISelectState> {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            id: Math.random().toString(16),
        };
        this.toggleView = this.toggleView.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    toggleView(e) {
        stopBubbling(e);
        this.setState({ isOpen: !this.state.isOpen });
    }

    closeMenu() {
        this.setState({ isOpen: false }, () => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        });
    }

    render() {
        const icon = this.state.isOpen ? (
            <KeyboardArrowUp className={Styles.selectIcon} />
        ) : (
            <KeyboardArrowDown className={Styles.selectIcon} />
        );

        const popoverAnchor = this.props.anchor
            ? this.props.anchor
            : {
                  horizontal: 'left',
                  vertical: 'bottom',
              };

        const selectHtml = (
            <div
                id={`${this.props.id}-container`}
                className={cx(
                    Styles.domElContainer,
                    this.props.containerClassName
                )}
                style={this.props.containerStyle}
                title={this.props.title}
            >
                {this.props.label && <Label text={this.props.label} />}
                <div
                    className={Styles.selectContainer}
                    id={this.state.id}
                    onClick={(e) => this.toggleView(e)}
                >
                    <span
                        id={this.props.id}
                        style={this.props.inputStyle}
                        className={Styles.select}
                    >
                        {this.props.value === null && this.props.placeholder
                            ? this.props.placeholder
                            : this.props.value}
                    </span>
                    {icon}
                </div>
                <Popover
                    open={this.state.isOpen}
                    anchorEl={document.getElementById(this.state.id)}
                    onClose={this.closeMenu}
                    TransitionProps={{ timeout: 0 }}
                    PaperProps={{
                        sx: {
                            borderRadius: 0,
                            boxShadow: 'none',
                            transition: 'none',
                        },
                    }}
                    anchorOrigin={popoverAnchor}
                >
                    <div className={Styles.selectOptionsContainer}>
                        {this.props.children}
                    </div>
                </Popover>
            </div>
        );

        return this.props.tooltip ? (
            <Tooltip title={this.props.tooltip} placement="left">
                {selectHtml}
            </Tooltip>
        ) : (
            selectHtml
        );
    }
}

export default Select;
